export enum ChatActionTypes {
  GET_CHAT_LIST = "@@CHAT/GET_CHAT_LIST",
  GET_CHAT_LIST_SUCCESS = "@@CHAT/GET_CHAT_LIST_SUCCESS",
  GET_CHAT_LIST_FAILURE = "@@CHAT/GET_CHAT_LIST_FAILURE",

  GET_CHAT = "@@CHAT/GET_CHAT",
  GET_CHAT_SUCCESS = "@@CHAT/GET_CHAT_SUCCESS",
  GET_CHAT_FAILURE = "@@CHAT/GET_CHAT_FAILURE",

  UPDATE_CHAT = "@@CHAT/UPDATE_CHAT",
  UPDATE_CHAT_SUCCESS = "@@CHAT/UPDATE_CHAT_SUCCESS",
  UPDATE_CHAT_FAILURE = "@@CHAT/UPDATE_CHAT_FAILURE",

  DELETE_CHAT = "@@CHAT/DELETE_CHAT",
  DELETE_CHAT_SUCCESS = "@@CHAT/DELETE_CHAT_SUCCESS",
  DELETE_CHAT_FAILURE = "@@CHAT/DELETE_CHAT_FAILURE",

  REACT_TO_MESSAGE = "@@CHAT/REACT_TO_MESSAGE",
  REACT_TO_MESSAGE_SUCCESS = "@@CHAT/REACT_TO_MESSAGE_SUCCESS",
  REACT_TO_MESSAGE_FAILURE = "@@CHAT/REACT_TO_MESSAGE_FAILURE",

  GET_STARTERS = "@@CHAT/GET_STARTERS",
  GET_STARTERS_SUCCESS = "@@CHAT/GET_STARTERS_SUCCESS",
  GET_STARTERS_FAILURE = "@@CHAT/GET_STARTERS_FAILURE",

  GET_QUOTA = "@@CHAT/GET_QUOTA",
  GET_QUOTA_SUCCESS = "@@CHAT/GET_QUOTA_SUCCESS",
  GET_QUOTA_FAILURE = "@@CHAT/GET_QUOTA_FAILURE",

  SET_FILTER = "@@CHAT/SET_FILTER",
  CLEAR_CHAT = "@@CHAT/CLEAR_CHAT",
  CLEAR_CHATS = "@@CHAT/CLEAR_CHATS",
}
